import { Repository } from "src/firebase/firestore/repository";
import { AICoachPrompt } from "./entities/ai-coach-prompt.entity";

class AICoachPromptsRepository extends Repository<AICoachPrompt> {
  constructor() {
    super("ai_coach_prompts");
  }

  async find(args: any): Promise<(AICoachPrompt & { id: string })[]> {
    return await super.find(args) as (AICoachPrompt & { id: string })[];
  }
}

export const aiCoachPromptsRepository = new AICoachPromptsRepository();
